import { render, staticRenderFns } from "./PreviousAddressOccupancy.vue?vue&type=template&id=1f2fd411"
import script from "./PreviousAddressOccupancy.vue?vue&type=script&lang=js"
export * from "./PreviousAddressOccupancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports